import React from "react";
import { Button, Text, Card, CardContent } from "./index";
import { Icon } from "./Icon";

export interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  actionLabel?: string;
  actionLabelIcon?: string;
  onAction?: () => void;
  className?: string;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, actionLabel, actionLabelIcon, onAction, className }, ref) => {
    return (
      <Card
        className={className}
        ref={ref}
      >
        <CardContent className="flex flex-col items-center justify-center !py-6">
          <Icon
            name={icon}
            size={24}
            className="text-gray-300 dark:text-gray-600 mb-2"
          />
          <Text className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{title}</Text>
          <Text className="text-xs text-gray-400 dark:text-gray-500 text-center max-w-xs mb-3">{description}</Text>
          {actionLabel && (
            <Button
              variant="ghost"
              onClick={onAction}
              className="!text-xs"
            >
              <Icon
                name={actionLabelIcon || "add"}
                size={14}
                className="mr-1"
              />
              {actionLabel}
            </Button>
          )}
        </CardContent>
      </Card>
    );
  },
);

EmptyState.displayName = "EmptyState";
